export const HASH_BYTES_LENGTH = 32;
//# sourceMappingURL=hash.js.map